'use strict';

import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { isEmpty, size, sumBy, get} from 'lodash'
import { getPaymentsNEW, linkPaymentsTo5000, unLinkPaymentsTo5000, getIncomeInfo, getPaymentSmsInfo } from '../../../../../jsx/actions/paymentAction';
import RepayDashboard from './Repayment/RepayDashboard.jsx';
import CardPage from '../../commonModules/layouts/CardPage.jsx';
import { Box, TableBody, TableRow, TableCell, TableHead, Card, AppBar, Tabs, Tab, IconButton, Checkbox, Button, TableSortLabel } from '@material-ui/core';
import { TableLayout } from './Stock/containers/Layout.jsx';
import { IndeterminateCheckBoxOutlined ,CloudDownloadRounded, Add, AddRounded} from '@material-ui/icons';
import Spin from '../../commonModules/interface/Spin';
import { amber, blue, red, yellow } from '@material-ui/core/colors';
import TableFooterPagination from '../../commonModules/interface/TableFooterPagination.jsx';
import FilterList from '../AdminDashboard/Layouts/FilterList.jsx';
import { firstDayOfYear } from '../../commonModules/utils/statsFunctions.jsx';
import LinkPaymentPopUp from './Repayment/LinkPaymentPopUp.jsx';
import PaymentSingle from './Repayment/PaymentSingle.jsx';
import DeleteDialog from '../../commonModules/interface/DeleteDialog';
import { toast } from 'react-toastify';
import Spinner from 'react-spinner-material';

class PaymentList extends Component{
	state = {
		paymentList: [],
		paymentListAll: [],
		sortDSC: false,

		view: "Liste",
		pageOfItems:[],
		currentPage:0,
		rowsPerPage:20,
		checkedPayments: [],
		totalPay: 0,
		incomeID: "",
		openLink: false,
		openUnLink: false,
		unlink: {},
		openSingle: false,
		selected: {},

		searchMethod: {label:"", value:""},
		searchClient: {label:"", value:""},
		matched: {label:"", value:""},
		searchFacture: "",
		start_date: firstDayOfYear,
        end_date: new Date(),
	}

	componentWillMount = async () => {
		console.log("PaymentList  componentWillMount ")
		if(!this.props.PAYMENT_STATE.fetching && !this.props.PAYMENT_STATE.fetched){
			await this.props.getPaymentsNEW(this.state.start_date,this.state.end_date,[""])
		}
		// this.filterList()
	}
	
	onChangePage = (pageOfItems, currentPage, rowsPerPage) => {
		// update state with new page of items
		this.setState({ pageOfItems, currentPage, rowsPerPage });
	}
	orderByDatePaiement = (list) => {
		console.log("IN SORT DATE");
		
		if (!this.state.sortDSC) {
			list.sort((a, b) => {
				a = new Date(a.timePayment);
				b = new Date(b.timePayment);
				if (a > b) {
					return -1;
				}
				if (a < b) {
					return 1;
				}
				return 0;
			});
		} else {
			list.sort((a, b) => {
				a = new Date(a.timePayment);
				b = new Date(b.timePayment);
				if (a < b) {
					return -1;
				}
				if (a > b) {
					return 1;
				}
				return 0;
			});
		}
		// this.setState({
		// 	sortDSC: sortingState
		// });
		return list
	}

	filterList = () => {
		const { PAYMENTS } = this.props;
		const { searchFacture, searchClient, searchMethod, matched } = this.state;
		
		let filteredList = this.filterDate(PAYMENTS)
		if(!isEmpty(searchFacture)){
			filteredList = filteredList.filter(item => item.transactionId.indexOf(searchFacture.toLocaleLowerCase()) > -1)
		}
		if( matched.value !== "" ) {
            filteredList = filteredList.filter( item => !!item.income_id === matched.value)
        }
		if( !isEmpty(searchClient.value)) {
            filteredList = filteredList.filter( item => item.boxId === searchClient.value)
        }
        if( Array.isArray(searchClient) && !isEmpty(searchClient) ) {
            let itemList = searchClient.map(item => item.value )
            filteredList = filteredList.filter( item => itemList.includes(item.boxId))
        }
		if( !isEmpty(searchMethod.value)) {
            filteredList = filteredList.filter( item => item.methodPayment === searchMethod.value)
        }
        if( Array.isArray(searchMethod) && !isEmpty(searchMethod) ) {
            let itemList = searchMethod.map(item => item.value )
            filteredList = filteredList.filter( item => itemList.includes(item.methodPayment))
        }

		filteredList = this.orderByDatePaiement(filteredList)
		
		return filteredList
	}
	filterDate = (list, from = this.state.start_date, to = this.state.end_date) => {
		console.log('====================================');
		console.log({list, from, to});
		console.log('====================================');
		if(!to){
			to = Date.now()
		}
		from = new Date(from).setHours(0,0,0,0)
		to = new Date(to).setHours(23,59,59,0)
		console.log('NEW DATE',{list, from, to});

		let filteredList = Object.values(list).filter( pay => 
			new Date(pay.timePayment) >= from 
			&& new Date(pay.timePayment) <= to
		)

		return filteredList
	}
	
	handleSelect = (option, name) => {
        if(option){
            this.setState({                
                [name]: option,
                currentPage: 0,
                // checkedItems :[]
            })
        } else {
            this.setState({
                [name]: {label: "", value: ""},
                currentPage: 0,
                // checkedItems :[]
            })

        }
    }
	handleChange = (e) => {
		const { name, value } = e.target;
		this.setState({
			[name]: value,
			currentPage: 0,
			currentPageProd: 0,
		})
	}
    handleChangeDate = async (date, name) => {

		this.setState({
			[name]: date
		})
		await this.props.getPaymentsNEW(this.state.start_date,this.state.end_date,[""])
	}
	createPaymentList = () => {
		let { currentPage, rowsPerPage, checkedPayments } = this.state
		const isSelected = name => checkedPayments.indexOf(name) !== -1;
		const BCKG = income_id => !!income_id ? amber[50]: 'initial';
		let paymentList = this.filterList()
		console.log("createPaymentList len ",paymentList.length)

		// let BCKG = 'initial'
		// if payment.income_id !== "" {
		// 	BCKG = amber[100]
		// } 

		if( !isEmpty(paymentList) ){
			return {
				list: paymentList.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage).map( (payment, index) => 
					<TableRow 
						key={payment.timePayment} 
						hover
						style={{
							background: payment.Status === "cancel" ? red[100] : BCKG(payment.income_id)
						}}
					>
						<TableCell 
							padding="checkbox"
						>
							{!!!payment.income_id &&
								<Checkbox
									onClick={event => this.handleClick(event, payment.paymentID)}
									// disabled={!!payment.income_id}
									checked={isSelected(payment.paymentID)}
									inputProps={{ 'aria-labelledby': `enhanced-table-checkbox-${index}` }}
								/>
							}
							{!!payment.income_id &&
							<Box p={1}>
								<IndeterminateCheckBoxOutlined
									onClick={() => this.setState({unlink: payment, openUnLink: true})}
									style={{color: red[100]}}
									// indeterminate
									// inputProps={{ 'aria-labelledby': `enhanced-table-checkbox-${index}` }}
								/>
							</Box>
							}
						</TableCell>
						<TableCell>{new Date(payment.timePayment).toLocaleString('fr-FR')}</TableCell>
						<TableCell>{payment.transactionId && payment.transactionId.substring(0, 9)}</TableCell>
						<TableCell>{new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format(payment.money)}</TableCell>
						<TableCell>{payment.boxId}</TableCell>
						<TableCell>{payment.userName}</TableCell>
						<TableCell>{payment.methodPayment}</TableCell>
						<TableCell>{payment.day}</TableCell>
						<TableCell>{payment.codeId}</TableCell>
						<TableCell>
							<IconButton onClick={() => this.handleSinglePayment(payment)}>
								<AddRounded />
							</IconButton>
						</TableCell>
					</TableRow>
				),
				size: size(paymentList),
				listAll: paymentList.map(pay => pay.paymentID),
				listItems: paymentList
			}
		}
		return {list: [], size: 0, listAll: []}
	}

	handleSinglePayment = (payment) => {

		this.setState({ 
			selected: payment,
			openSingle: true
		})
	}
	handleClick = (event, payID) => {
		const { PAYMENTS } = this.props;
        const { checkedPayments } = this.state;
        const selectedIndex = checkedPayments.indexOf(payID);
        let newSelected = [];
    
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(checkedPayments, payID);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(checkedPayments.slice(1));
        } else if (selectedIndex === checkedPayments.length - 1) {
            newSelected = newSelected.concat(checkedPayments.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                checkedPayments.slice(0, selectedIndex),
                checkedPayments.slice(selectedIndex + 1),
            );
        }
    
        this.setState({
            checkedPayments : newSelected,
			totalPay: this.calcTotal(newSelected)
        });
    };
	handleSelectAllClick = (event, list) => {
		const { PAYMENTS } = this.props;
        if (event && event.target.checked) {
            // let filteredList = this.filterList()
            let newList = list.filter( payID => !!!PAYMENTS[payID].income_id)
			// console.log('================handleSelectAllClick====================');
			// console.log({newList});
			// console.log('====================================');
			this.setState({
				checkedPayments : newList,
				totalPay: this.calcTotal(newList)
			});
          return;
        }
        this.setState({
            checkedPayments : [],
			totalPay: 0,
			incomeID: "",
			openLink: false
        });
        
    };
	arrayEqual = ( arr1, arr2) => {
		const arr2Sorted = arr2.slice().sort();
		return arr1.length === arr2.length && 
			arr1.slice().sort().every((value, index) =>  value === arr2Sorted[index])
	}
	rmPayment = (payID) => {
		let newList = [].concat(this.state.checkedPayments)
		newList = newList.filter(id => id !== payID)
		this.setState({
            checkedPayments : newList,
			totalPay: this.calcTotal(newList)
        });
	}
	handleSubmitLink = async () => {
		const { PAYMENTS } = this.props;

		let paymentsID = Object.values(this.state.checkedPayments).map(pay => PAYMENTS[pay].paymentID )

		let data = {
			income_id : this.state.incomeID,
			payments: this.state.checkedPayments, 
			paymentsID, 
			total: this.calcTotal(this.state.checkedPayments)
		}
		await this.props.linkPaymentsTo5000(data)
		if(this.props.PAYMENT_STATE.error){
			console.log("ERROR", this.props.PAYMENT_STATE.error)				
			toast.error(  this.props.PAYMENT_STATE.error)
		} else {
			toast.info("Opération enregistrée avec succès")
			this.handleSelectAllClick()                        	
		}
	}
	handleSubmitUnLink = async () => {
		let data = {
			income_id : this.state.unlink.income_id,
			payments: [this.state.unlink.timePayment], 
			paymentsID: [this.state.unlink.paymentID], 
			total: this.state.unlink.money
		}
		await this.props.unLinkPaymentsTo5000(data)
		if(this.props.PAYMENT_STATE.error){
			console.log("ERROR", this.props.PAYMENT_STATE.error)				
			toast.error( this.props.PAYMENT_STATE.error)
		} else {
			toast.info("Opération enregistrée avec succès")
			this.handleSelectAllClick()                        	
		}
	}
	
	calcTotal = (list) => {
		const { PAYMENTS } = this.props;
		// let totalPay = 0
		
		// list.forEach(pay => totalPay += PAYMENTS[pay].money)
		// return totalPay
		return sumBy(list, (pay) => (PAYMENTS[pay].money))
	}

	handleDownloadCSV = () => {
		const { PAYMENTS } = this.props;
		const { checkedPayments } = this.state;
		
		// Get payments to export: checked ones if any, otherwise all filtered
		let paymentsToExport;
		if (checkedPayments.length > 0) {
			paymentsToExport = checkedPayments.map(id => PAYMENTS[id]).filter(Boolean);
		} else {
			paymentsToExport = this.filterList();
		}
		
		// Build CSV with headers
		let csv = "Date Paiement,Id Transaction,Montant,Box ID,Nom,Type Paiement,Durée paiement,Code Envoyé,Status,Pointé\n";
		
		paymentsToExport.forEach(payment => {
			csv += [
				new Date(payment.timePayment).toLocaleString('fr-FR'),
				payment.transactionId || '',
				payment.money || 0,
				payment.boxId || '',
				payment.userName || '',
				payment.methodPayment || '',
				payment.day || '',
				payment.codeId || '',
				payment.Status || '',
				payment.income_id ? 'Oui' : 'Non'
			].join(',') + '\n';
		});
		
		// Create and trigger download
		const link = document.createElement('a');
		link.href = "data:application/csv;charset=utf-8," + encodeURIComponent(csv);
		link.setAttribute('download', 'MyJouleBox-Payment-Data.csv');
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}
 
  	render () {
		const { openLink, openUnLink, unlink, checkedPayments, sortDSC, openSingle, selected } = this.state;
		const { PAYMENTS } = this.props;
		console.log('[INFO], render fonction User Repayment', this.state);

		let payments = this.state.view === "Liste" ? this.createPaymentList() : {list: [], size: 0}
		return (
			<CardPage 
				title="Liste des paiements" 
				subtitle="Etat des paiements paygo"
				action={
					<IconButton color="secondary" title="Télécharger" onClick={this.handleDownloadCSV}>
						<CloudDownloadRounded />
					</IconButton>
				}
			>
				{openSingle && selected &&
					<PaymentSingle
						payment={selected}
						getIncomeInfo={this.props.getIncomeInfo}
						getPaymentSmsInfo={this.props.getPaymentSmsInfo}
						handleClose={()=> this.setState({ selected: {}, openSingle: false})}
					/>
				}
				<Card>
					<AppBar position="static">
						<Tabs
							value={this.state.view}
							onChange={(e, view) => this.setState({ view })}
							indicatorColor="secondary"
							variant="fullWidth"
							scrollButtons="auto"
						>
							<Tab value="Dashboard" label="Dashboard"/>
							<Tab value="Liste" label="Liste"/>
						</Tabs>
					</AppBar>
					
					<Box p={2}>
						{this.state.view === "Dashboard" ? (
							<RepayDashboard />
						) : (
							<Box>
								<Box p={1}>
									{/* <SearchBar list={ this.props.PAYMENTS } filterList={this.filterList}/> */}
									{PAYMENTS &&
										<FilterList 
											PAYMENTS={ this.props.PAYMENTS }
											handleChange={this.handleChange}
											handleSelect={this.handleSelect}
											handleChangeDate={this.handleChangeDate}
											{...this.state}
										/>
									}
								</Box>
								{size(checkedPayments) > 0 &&
									<Button variant="contained" color="primary" onClick={()=> this.setState({ openLink : true })}>
										Pointer {size(checkedPayments)} paiements
									</Button>
								}
								{openLink && size(checkedPayments) > 0 &&
									<LinkPaymentPopUp
										handleClose={()=> this.setState({ openLink : false, incomeID: "" })}
										rmPayment={this.rmPayment}
										handleSubmitLink={this.handleSubmitLink}
										handleChange={(e) => this.setState({[e.target.name]: e.target.value})}
										{...this.props}
										{...this.state}
									/>
								}
								{openUnLink && !isEmpty(unlink) &&
									<DeleteDialog 
										open={true}
										title="le pointage"
										close={()=> this.setState({ openUnLink: false, unlink: {}})}
										handleSubmit={this.handleSubmitUnLink}
									/>
								}
								
								{this.props.PAYMENT_STATE.fetching ?
									<Box p={1} style={{ position: "relative", left:"46%"}}>
										<Spinner color="primary" />
									</Box>
								:
								<TableLayout>
									<TableHead>
										<TableRow>
											<TableCell padding="checkbox">
												<Checkbox
													indeterminate={size(checkedPayments) > 0 && size(checkedPayments) < payments.size}
													checked={payments.size > 0 && this.arrayEqual(payments.listAll, checkedPayments)}
													onChange={(e) => this.handleSelectAllClick(e, payments.listAll)}
													inputProps={{ 'aria-label': 'Selectionner tout' }}
												/>
											</TableCell>
											{/* <TableCell component="th" 
												onClick={() => this.setState({ sortDSC: !this.state.sortDSC})}
												>
												Date Paiement
											</TableCell> */}
											<TableCell
												sortDirection={sortDSC}
												component="th" 
											>
												<TableSortLabel
													active={true}
													direction={sortDSC ? 'desc' : 'asc'}
													onClick={() => this.setState({ sortDSC: !this.state.sortDSC})}
												>
													Date Paiement
												</TableSortLabel>
											</TableCell>
											<TableCell component="th">Id Transaction</TableCell>
											<TableCell component="th">Montant</TableCell>
											<TableCell component="th">Box ID</TableCell>
											<TableCell component="th">Nom</TableCell>
											<TableCell component="th">Type Paiement</TableCell>
											<TableCell component="th">Durée paiement</TableCell>
											<TableCell component="th">Code Envoyé</TableCell>
											<TableCell component="th">Infos</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{payments.list}
										{!this.props.PAYMENT_STATE.fetched &&
											<TableRow>
												<TableCell colSpan={9}><Spin noOverlay={true}/> </TableCell>
											</TableRow>									
										}
									</TableBody>
									
									<TableFooterPagination
										colSpan={10}
										count={payments.size} 
										onChangePage={this.onChangePage} 
										initialPage={this.state.currentPage} 
									/>
								</TableLayout>	
								}
								
							</Box>
						)}
					</Box>
				</Card>    
			</CardPage>
					
		);
  	}
};
function mapStateToProps(state){// transform elements from store's state into props in this component
    return {
      PAYMENT_STATE: state.inventory.requestState.payments,
      PAYMENTS: state.payments,
    }
}

function mapDispatchToProps(dispatch){
    return bindActionCreators({
	  getPaymentsNEW,
	  linkPaymentsTo5000,
	  unLinkPaymentsTo5000,
	  getIncomeInfo,
	  getPaymentSmsInfo,
    }, dispatch)
}
export default connect(mapStateToProps, mapDispatchToProps )(PaymentList);

